import React from "react";
import { useState, useEffect, useRef } from "react";
import { getTickerHistoricals } from "../../services/TickerHistoricalService";
import ReactEcharts from "echarts-for-react"

const TickerHistorical = ({param}) => {

    const chartRef = useRef(null);

    const [pricetrangepercs, setPricetrangepercs] =  useState([]);
    const [seriesdata1, setSeriesdata1] = useState([]);
    const [seriesdata2, setSeriesdata2] = useState([]);

    useEffect(() => {
        const interval = setInterval(() => { getTickerHistoricalsData(); setTickerHisticals(); }, 1000);
        const chartInstance = chartRef.current.getEchartsInstance();
        // update the chart
        chartInstance.setOption({
            series: [
                { data: seriesdata1 },
                { data: seriesdata2 }
            ]
        });
        return () => { clearInterval(interval); }
    });

    function getTickerHistoricalsData() {
        getTickerHistoricals(param).then((response) => {
            setPricetrangepercs(response.data);
        }).catch(error => {
            console.log(error);
        })
    }

    function setTickerHisticals() {
        var ignore = pricetrangepercs.length - 10;
        var data1 = []; var data2 = [];

        for (let i = 0; i < pricetrangepercs.length; i++) {
            if (ignore <= 0)
            {   data1.push(pricetrangepercs[i].pricePercent.toFixed(4));
                data2.push(pricetrangepercs[i].trangePercent.toFixed(4));
            } ignore--;
        } setSeriesdata1(data1); setSeriesdata2(data2);
    }

    const [options] = useState({
        title: {    display: true,
                    text: "", // PrTr Price x Trange
                    textStyle: {
                        fontFamily: 'Arial',
                        fontSize: 13,
                        fontWeight: 'normal',
                        opacity: 1.0,
                    },
                    align: 'center',
                    position: 'bottom',
                    padding: {
                        top: 0,
                        bottom: 0
                    }
                },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {   show: false     },
        yAxis: {    type: "value",
                    boundaryGap: [0, 0.01],
               },
        xAxis: {    type: "category",
                    data: ['90s', '80s', '70s', '60s', '50s', '40s', '30s', '20s', '10s', '0s' ],
                },  
        series: [
                    {   name: "Percent",
                        type: "bar",
                        data: [],
                        itemStyle: {    color: function(params) {   // Customize color based on the index
                                                                    // const colors = ['#d82518bb' ];
                                                                    // return colors[params.dataIndex];
                                                                    return params.value >= 0 ? 'green' : '#d82518bb'
                                                                }
                                    },
                        smooth: true,
                    },
                    {   name: "Trange",
                        type: "bar",
                        data:  [],
                        itemStyle: {    color: function(params) {   
                                                                    return '#af1aaf8c'
                                                                }
                                    },
                        smooth: true,
                    },
                ],
        grid: {
            top: 40,
            bottom: 30,
            left: 0,
            right: 0,
        }
    });

    return (
        <ReactEcharts
            ref={chartRef}
            option={options}
            style={{ width: "420px", height: "280px" }}>
        </ReactEcharts>
    )
}

export default TickerHistorical;
